import { useQuery } from '@tanstack/react-query'
import { sortBySequenceNumber } from 'shared/lib/common-util'
import { QueryKeys } from '../../../key-registry'
import { fromAdditionalReferenceResponse } from '../models/mapper'
import { AdditionalReference, AdditionalReferenceParentType } from '../models/types'
import { fetchAdditionalReferencesV2 } from './http'

export async function fetchAdditionalReferences(
  params: {
    parentId: number
    parentType: AdditionalReferenceParentType
  },
  opts?: { signal?: AbortSignal },
): Promise<AdditionalReference[]> {
  const responses = await fetchAdditionalReferencesV2(params, opts)

  return responses.map((
    response,
    index,
  ) => fromAdditionalReferenceResponse(response, params.parentType, params.parentId, index))
    .sort(sortBySequenceNumber)
}

export function useFetchAdditionalReferences(
  { parentId, parentType }: { parentId: number | null; parentType: AdditionalReferenceParentType },
) {
  return useQuery({
    queryKey: QueryKeys.additionalReference.allByParams({ parentId, parentType }),
    queryFn: ({ signal }) => fetchAdditionalReferences({
      parentId: parentId as number,
      parentType,
    }, { signal }),
    enabled: !!parentId,
  })
}
